import * as api from "Api";
import * as actions from "Actions";

export const fetchDashboard = (year, uen, target = null, id = null) => {
  return (dispatch, getState) => {
    const { lng } = getState().params;
    const { token } = getState().auth;

    return dispatch(
      actions.fetchDashboard(
        api.getDashboard({
          uen: uen,
          target: target,
          id: id,
          language: lng,
          token: token,
          year: year
        })
      )
    );
  };
};

export const fetchGeneralAssociationDashboard = () => {
  return (dispatch, getState) => {
    const {
      auth: { currentOrganization }
    } = getState();

    const { uen } = currentOrganization;
    dispatch(
      actions.fetchGeneralAssociationDashboard(
        api
          .getGeneralAssociationDashboard({
            uen: uen
          })
          .then(res => {
            const data = res.data.data;
            return data;
          })
      )
    );
  };
};

export const saveGeneralAssociationDashboard = ({ associations }) => {
  return (dispatch, getState) => {
    const { created, standard } = getState().organizations.association;
    const { backOffice } = getState().params.backOffice;
    let association = backOffice ? standard : created;
    return dispatch(
      actions.saveAssociationDashboard(
        api.associateDashboardToFormLegal({
          association
        })
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/dashboard.js